import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard, movie, film"><path d="M21 19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V9.5H21V19.25Z" fill="currentColor"/><path d="M7.20898 8H3V4.75C3 3.7835 3.7835 3 4.75 3H8.87598L7.20898 8Z" fill="currentColor"/><path d="M13.459 8H8.79102L10.458 3H15.126L13.459 8Z" fill="currentColor"/><path d="M19.25 3C20.2165 3 21 3.7835 21 4.75V8H15.041L16.708 3H19.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClapboard;
